import { Rate } from '@/api'

const rate = new Rate()
import cloneDeep from 'lodash.clonedeep'

const RESTAURANT_TYPE = 'restaurant'
const MEAL_TYPE = 'meal'

export default {
    data() {
        return {
            loadingOrder: false,
            loadingMeal: null,
        }
    },
    computed: {
        rate: () => rate,
        isThisYear() {
            return this.$moment().isSame(this.order.required_delivery_time, 'year')
        },
        meals() {
            return this.order.items
        },
        canRateMeals() {
            return Boolean(this.meals.find((meal) => Boolean(meal.meal)))
        },
    },
    methods: {
        async rateOrder(val) {
            this.loadingOrder = true
            const edit = !!this.order?.restaurant_rating?.id
            const backup = cloneDeep(this.order.restaurant_rating)
            if (!this.order.restaurant_rating) this.order.restaurant_rating = {}
            this.rate.updateModel({
                id: edit ? this.order.restaurant_rating.id : this.order.restaurant.id,
                note: undefined,
                order: edit ? undefined : this.order.link,
                rating: val,
            })
            this.$set(this.order, 'restaurant_rating', cloneDeep(this.rate.model))
            try {
                const result = edit
                    ? await this.rate.editRate()
                    : await this.rate.rate(RESTAURANT_TYPE)
                this.$set(this.order.restaurant_rating, 'id', result.id)
            } catch (err) {
                this.$set(this.order, 'restaurant_rating', backup)
            }
            this.loadingOrder = false
        },
        async rateMeal(index, val) {
            this.loadingMeal = this.meals[index].id
            const edit = !!this.meals?.[index]?.meal_rating?.id
            const backup = cloneDeep(this.meals[index].meal_rating)
            if (!this.meals[index].meal_rating) this.meals[index].meal_rating = {}
            this.rate.updateModel({
                id: edit ? this.meals[index].meal_rating.id : this.meals[index].meal?.id,
                note: undefined,
                order: edit ? undefined : this.order.link,
                rating: val,
            })
            this.$set(this.meals[index], 'meal_rating', cloneDeep(this.rate.model))
            try {
                const result = edit ? await this.rate.editRate() : await this.rate.rate(MEAL_TYPE)
                this.$set(this.meals[index].meal_rating, 'id', result.id)
            } catch (err) {
                this.$set(this.meals[index], 'meal_rating', backup)
            }
            this.loadingMeal = null
        },
    },
}
